
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class PermissionModel extends Model<PermissionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflowAccess', type: 'boolean', languageString: 'permission.property.taskflowAccess' },
		{ name: 'taskActionAccess', type: 'boolean', languageString: 'permission.property.taskActionAccess' }
	];
	[key: string]: any;
	
	public taskflowAccess: boolean;
	public taskActionAccess: boolean;
    
	constructor(){
		super();
		this.taskflowAccess = false;
		this.taskActionAccess = false;
		
	}
	getProperties(){
		return PermissionModel.classProperties;
	}
}

